import { MarkAsTemplate } from "@project/domain/models/budget-template/mark-as-template";
import { injectable } from "inversify";

@injectable()
export class MarkAsTemplateMapper {
    map(markAsTemplate: MarkAsTemplate): any {
        return {
            budget_id: markAsTemplate.budget_id,
        };
    }
}
